const STAGE_LABEL = {
  one_line: "1 LINE",
  two_lines: "2 LINES",
  full_house: "FULL HOUSE",
};

/**
 * StageLabel — "Playing for: 1 LINE" prominent on the Projector.
 */
export default function StageLabel({ stage }) {
  return (
    <div
      data-testid="projector-stage-label"
      className="ic-font-display flex flex-col items-end"
    >
      <span
        className="text-[10px] tracking-[0.4em] uppercase"
        style={{ color: "var(--ic-text-muted)" }}
      >
        Playing for
      </span>
      <span
        className="font-bold mt-1"
        style={{
          fontSize: "clamp(1.4rem, 2.2vw, 2.4rem)",
          color: "var(--ic-primary)",
          letterSpacing: "0.05em",
          textShadow: "0 0 20px var(--ic-primary-glow)",
        }}
      >
        {STAGE_LABEL[stage] || STAGE_LABEL.one_line}
      </span>
    </div>
  );
}
